<template>
  <VersionSelect v-if="plp_task_id" fluid>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <cr-list
        :value="data"
        :readonly="readonly"
        :onCreate="onCreate"
        :onChange="onChange"
        @change="onChange"
        @blur="onBlur"
      ></cr-list>
    </template>
  </VersionSelect>
</template>

<script>
import { mapGetters } from 'vuex'
import VersionSelect from '@/components/VersionSelect'
import crList from '@/components/expAnalogs/crList'

export default {
  components: { VersionSelect, crList },
  computed: {
    ...mapGetters(['plp_task_id']),
  },
}
</script>

<style scoped>
.container {
  width: 100%;
}
</style>
